class Loader {
    start () {
        $('body').prepend(this.loaderHtml())
    }

    stop () {
        $('body').find('.' + this.loaderClass()).remove()
    }

    loaderHtml () {
        return `<div class="loader-wrapper ${this.loaderClass()}"><div class="loader bg-white"><div class="whirly-loader"></div></div></div>`
    }

    loaderClass () {
        return 'js-loader-container'
    }
}

const loader = new Loader()

export default loader
